import { render } from "./index.vue?vue&type=template&id=aca31228&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=aca31228&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-aca31228"

export default script